export default "__VITE_ASSET__a87feccf__"